var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYouTubeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.041,
    height: 16.117,
    viewBox: "0 0 23.041 16.117",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_30473",
    "data-name": "Group 30473",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "YouTube_full-color_icon__2017_",
    "data-name": "YouTube_full-color_icon_(2017)",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_19",
    "data-name": "Subtraction 19",
    d: "M11.821,16.1c-1.986,0-3.982-.045-5.619-.127a25.561,25.561,0,0,1-3.686-.362A2.883,2.883,0,0,1,.482,13.574,25.5,25.5,0,0,1,0,8.031a27.845,27.845,0,0,1,.466-5.5A2.887,2.887,0,0,1,2.5.5,54.263,54.263,0,0,1,11.356,0c4.42,0,8.43.212,9.131.483a2.871,2.871,0,0,1,1.289.744,2.9,2.9,0,0,1,.745,1.29,16.94,16.94,0,0,1,.389,2.517c.083.931.125,1.938.123,2.994a27.612,27.612,0,0,1-.5,5.545A2.881,2.881,0,0,1,20.5,15.609a21.821,21.821,0,0,1-3.465.37C15.548,16.056,13.744,16.1,11.821,16.1ZM9.283,4.6h0v6.9L15.3,8.045Z",
    transform: "translate(0.006 0.018)",
    fill: "#05132e"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouTubeIcon);
export default __webpack_public_path__ + "static/media/youTubeIcon.2b4a91eb14d90b12e84b5333e6f08a3d.svg";
export { ForwardRef as ReactComponent };